<!--
    @description : 药品图片列表页面（一级页面）
    @api-property :
    @api-event :
    @api-method :

    @author :
    @dateTime :
    @lastEditDateTime :
    @lastEditors :
-->
<template>
  <div class="medicine-info-container">
    <!-- 页面标题 -->
    <div class="header-section">
      <h1 class="page-title">药品信息</h1>
    </div>

    <!-- 药品列表区域 -->
    <div class="medicine-list-section">

      <!-- 药品网格列表 -->
      <div class="medicine-grid">
        <div
          v-for="medicine in filteredMedicines"
          :key="medicine.id"
          class="medicine-card"
          @click="goToMedicineDetail(medicine.id)"
          style="cursor: pointer;"
        >
          <div class="medicine-card-image">
            <el-image
              :src="medicine.imageUrl"
              fit="contain"
              lazy
              :preview-src-list="[medicine.imageUrl]"
            ></el-image>
          </div>
          <div class="medicine-card-info">
            <h3 class="medicine-card-name">{{ medicine.name }}</h3>
            <p class="medicine-card-desc">{{ medicine.description }}</p>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="filteredMedicines.length === 0" class="empty-state">
        <el-empty description="暂无符合条件的药品"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MedicineInfo',
  methods: {
    // 跳转到药品详情页
    goToMedicineDetail(medicineId) {
      this.$router.push({
        name: 'medicineDetail',
        query: { id: medicineId }
      })
    }
  },
  data() {
    return {
      // 药品列表数据
      medicines: [
        {
          id: 'M003',
          name: '复方氨酚烷胺胶囊(快克)',
          imageUrl: require('@/assets/medicine/M003.jpg'),
          description: '适用于缓解普通感冒及流行性感冒引起的发热，头痛，四肢酸痛等症状。'
        },
        {
          id: 'M022',
          name: '氯雷他定片(开瑞坦)',
          imageUrl: require('@/assets/medicine/M022.jpg'),
          description: '用于缓解过敏性鼻炎有关的症状，如喷嚏、流涕、鼻痒、鼻塞以及眼部痒及烧灼感。'
        },
        {
          id: 'MED003',
          name: '布洛芬混悬液(美林) 100ml',
          imageUrl: require('@/assets/medicine/MED003.png'),
          description: '用于儿童普通感冒或流感引起的发热，也用于缓解儿童轻至中度疼痛。'
        },
        {
          id: 'M052',
          name: '小儿氨酚黄那敏颗粒(999) 6g*10袋',
          imageUrl: require('@/assets/medicine/M052.png'),
          description: '适用于缓解儿童普通感冒及流行性感冒引起的发热、头痛、四肢酸痛等症状。'
        },
        {
          id: 'MED005',
          name: '铝碳酸镁咀嚼片(达喜)',
          imageUrl: require('@/assets/medicine/MED005.png'),
          description: '用于慢性胃炎与胃酸有关的胃部不适应症，如胃疼，胃灼热感（烧心)，酸性嗳气，饱胀。'
        }
      ],
      // 搜索关键词
      searchKeyword: ''
    }
  },
  computed: {
    // 筛选后的药品列表
    filteredMedicines() {
      let result = [...this.medicines]
      
      // 根据关键词搜索
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase()
        result = result.filter(medicine => 
          medicine.name.toLowerCase().includes(keyword) ||
          medicine.description.toLowerCase().includes(keyword)
        )
      }
      
      return result
    }
  }
}
</script>

<style scoped lang="less">
.medicine-info-container {
  padding: 20px;
  background-color: #f5f7fa;
  
  .header-section {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px 0;
    background-color: #409EFF;
    border-radius: 8px;
    color: white;
    
    .page-title {
      font-size: 24px;
      font-weight: bold;
    }
    
    .page-subtitle {
      font-size: 14px;
      opacity: 0.9;
    }
  }
  
  .medicine-list-section {
    
    .search-section {
      margin-bottom: 20px;
      
      .search-input {
        width: 100%;
        max-width: 500px;
      }
    }
    
    .medicine-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(370px, 1fr));
      gap: 20px;
      
      .medicine-card {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        
        .medicine-card-image {
          height: 180px;
          overflow: hidden;
          
          .el-image {
            width: 100%;
            height: 100%;
          }
        }
        
        .medicine-card-info {
          padding: 15px;
          
          .medicine-card-name {
            font-size: 16px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 8px;
          }
          
          .medicine-card-desc {
            font-size: 13px;
            color: #606266;
            line-height: 1.5;
            margin: 0;
          }
        }
      }
    }
    
    .empty-state {
      text-align: center;
      padding: 40px 0;
      background-color: white;
      border-radius: 8px;
      margin-top: 20px;
    }
  }
}

/* 简单的响应式设计 */
@media screen and (max-width: 768px) {
  .medicine-info-container {
    padding: 15px;
    
    .header-section {
      margin-bottom: 20px;
      
      .page-title {
        font-size: 20px;
      }
    }
    
    .medicine-list-section {
      .search-section {
        .search-input {
          max-width: 100%;
        }
      }
      
      .medicine-grid {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 15px;
        
        .medicine-card {
          .medicine-card-image {
            height: 140px;
          }
          
          .medicine-card-info {
            padding: 12px;
            
            .medicine-card-name {
              font-size: 14px;
            }
            
            .medicine-card-desc {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>